import { useTranslations } from 'next-intl';
import { Gender } from '@/__generated__/graphql';
import type { Option } from '@/components/ui/select/select-native';

export const useGenderOptions = () => {
  const t = useTranslations();
  const genderOptions: Option[] = [
    { value: '', label: t('sign_up-profile-gender-placeholder') },
    { value: Gender.Male, label: t('options-gender-male') },
    { value: Gender.Female, label: t('options-gender-female') },
    { value: Gender.NoAnswer, label: t('options-gender-no_answer') },
  ];

  return { genderOptions };
};
